import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Box, Container } from '@mui/material'

import { setPage } from '../../store/slice/page'

import Copyright from '../../components/Copyright'
import SignUpForm from '../../containers/Form/SignUpForm'
import Footer from '../../containers/Footer'

import useStyles from './styles'

const SignUp = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPage('sign-up'))
  })

  return (
    <div className={classes.authPage}>
      <Container className={classes.xl_container}>
        <Box className={classes.container}>
          <Box className={classes.main_grid}>
            <Box className={classes.headline_wrp}>
              <div className={classes.headline_title}>Sign Up</div>
              <div className={classes.headline_subtitle}>And experience the power of true data-driven advertising.</div>
            </Box>
            <Box className={classes.main_form_wrp}>
              <SignUpForm />
            </Box>
          </Box>
          <Box className={classes.main_footer}>
            <Footer />
            <Box className={classes.main_copyright}>
              <Copyright />
            </Box>
          </Box>
        </Box>
      </Container>
    </div>
  )
}
export default SignUp
